import { STATUSPAGE } from '@repo/ui';
import { HandleRejectedByProfessionalsUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  loadRejectedByProfessionals,
  clearRejectedByProfessionals,
} from 'presentation/config/store/reports/rejected-by-professionals-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useRejectedByProfessionals = () => {
  const [loading, setLoading] = useState<STATUSPAGE>(STATUSPAGE.DONE);
  const [selectedSubmitBtn, setSelectedSubmitBtn] = useState<string>();
  const [hasFetchedData, setHasFetchedData] = useState(false);

  const dispatch = useDispatch();
  const { reportService } = useService();
  const { rejectedByProfessionals } = useAppSelector(
    (state) => state.rejectedByProfessionals,
  );

  // Methods PDF-EXCEL
  const requestHandleRejectedByProfessionals = useCallback(
    (params: HandleRejectedByProfessionalsUseCaseInterface.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleRejectedByProfessionals(params)
        .then((res: any) => {
          let blob = new Blob([res], {
            type: `application/${params?.type === 0 ? 'pdf' : 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'}`,
          });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          window.open(link.href, '_blank');
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  // Methods JSON
  const requestHandleRejectedByProfessionalsJson = useCallback(
    (params: HandleRejectedByProfessionalsUseCaseInterface.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .handleRejectedByProfessionals(params)
        .then((res: any) => {
          dispatch(loadRejectedByProfessionals(res));
        })
        .catch((err) => {
          dispatch(clearRejectedByProfessionals());
          notifyError(err.message);
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
          setHasFetchedData(true);
        });
    },
    [],
  );

  return {
    loading,
    hasFetchedData,
    selectedSubmitBtn,
    rejectedByProfessionals,
    setSelectedSubmitBtn,
    requestHandleRejectedByProfessionals,
    requestHandleRejectedByProfessionalsJson,
  };
};
